import { motion } from "framer-motion";
import styled, { css } from "styled-components";
import { ITexareaProps } from "./i-textarea";

export const Div = styled.div<{ fullWidth?: boolean | undefined }>`
   ${({ fullWidth }) => fullWidth && "width: 100%;"}
   position: relative;
   display: inline-block;
   width: 100%;
`;

export const Label = styled.label`
   pointer-events: none;
   color: ${({ theme }) => theme.colors?.grey};
   white-space: nowrap;
   margin-bottom: 0.3rem;

   font-size: 1.4rem;
   display: block;
   font-weight: 400;
   color: ${({ theme }) => theme.colors?.black};

   ${Div}:focus-within & {
      color: ${({ theme }) => theme.colors?.primary};
   }
`;

export const AdornmentWrapperDiv = styled.div`
   display: flex;
   align-items: center;
   white-space: nowrap;
   position: absolute;
   padding-left: 10px;
   margin-right: 10px;

   &.end {
      right: 0px;
      top: 30%;
   }
`;

export const InputFieldWrapperDiv = styled.div`
   position: relative;
   display: flex;
   align-items: center;
   width: 100%;

   ::before,
   ::after {
      content: "";
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
   }

   ::before {
      /* border-left: linear-gradient(270deg, #00d2ff -8.34%, #7e51ff 50.93%, #fa4a84 106.85%); */
      border-left: 1px solid ${({ theme }) => theme && theme.colors?.grey02};
   }

   ::after {
      border-left: 1px solid
         linear-gradient(270deg, #00d2ff -8.34%, #7e51ff 50.93%, #fa4a84 106.85%);
      transform: scaleY(0);
      transform-origin: center;
      height: 100%;
      transition: transform 0.25s;

      ${Div}:focus-within & {
         transform: scaleY(1);
      }
   }
`;

export const TextAreaField = styled.textarea<ITexareaProps>`
   width: 100%;
   border: none;
   outline: none;
   font-size: 1.5rem;
   appearance: none;
   border-radius: 0;
   padding: ${({ startAdornment }) => (startAdornment ? "3.8rem" : "1rem")};
   box-sizing: border-box;
   height: 192px;
   resize: none;
   border-radius: 0px;
   border: 1px solid rgb(243 242 242);
   background-color: ${({ theme }) => theme.colors?.grey01};
   -ms-overflow-style: none; /* IE and Edge */
   scrollbar-width: none; /* Firefox */

   &::-webkit-scrollbar {
      display: none;
   }

   &:focus {
      border-left: 1px solid grey;
   }

   &::-ms-clear {
      display: none;
   }

   &::-ms-expand {
      display: none;
   }

   &:-moz-ui-invalid {
      box-shadow: none;
   }

   &::placeholder {
      font-weight: 400;
      opacity: 0.4;
   }

   &:-webkit-autofill,
   &:-webkit-autofill:hover,
   &:-webkit-autofill:focus,
   &:-webkit-autofill:active {
      transition: background-color 5000s;
      -webkit-text-fill-color: #000 !important;
   }

   &:disabled {
      background-color: hsl(0, 0%, 95%);
   }
`;

export const ErrorP = styled(motion.p)<{ easyFlow?: boolean }>`
   margin: 0.1rem 0 0 0;
   color: ${({ theme }) => theme.colors?.redError};
   font-size: 1.4rem;
   letter-spacing: -0.01rem;
   font-weight: 400;

   ${({ easyFlow }) =>
      easyFlow &&
      css`
         margin: 0;
         position: absolute;
         left: 65px;
         bottom: -21px;
         font-size: 11.5px;
      `}
`;
